import { render, staticRenderFns } from "./RolePrivilegeSet.vue?vue&type=template&id=29843540"
import script from "./RolePrivilegeSet.vue?vue&type=script&lang=js"
export * from "./RolePrivilegeSet.vue?vue&type=script&lang=js"
import style0 from "./RolePrivilegeSet.vue?vue&type=style&index=0&id=29843540&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports